import SchemaTable from './SchemaTable';
import JoiSchemaTable from './JoiSchemaTable';

export {
  SchemaTable,
  JoiSchemaTable,
};



// WEBPACK FOOTER //
// ./src/components/index.js